module.exports = __webpack_public_path__ + "img/SAP_8649.7584544c.jpg";